import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';
import { observer } from 'mobx-react';

function ImportBillingTemplate({
	shipmentCostViewStore,
	shipmentCostViewStore: { uploadBillingData },
	t,
}) {
	return (
		<section className="ReactModal__form">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('SHIPMENTCOST.UPLOADMODALTITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<TrackingResultInfo shipmentCostViewStore={shipmentCostViewStore} t={t} />
			</div>
			<div className="ReactModal__footer flex--secondary">
				<div>
					<BaasicButton
						className="btn btn--med btn--primary spc--bottom--sml"
						onClick={() => uploadBillingData(true)}
						label="SHIPMENTCOST.OVERRIDE"
					/>
					<BaasicButton
						className="btn btn--med btn--primary spc--bottom--sml spc--left--sml"
						onClick={() => uploadBillingData(false)}
						label="SHIPMENTCOST.ADD"
					/>
				</div>
				<BaasicButton
					className="btn btn--med btn--ghost spc--bottom--sml spc--left--sml"
					onClick={() => shipmentCostViewStore.rootStore.viewStore.selectedModal.close()}
					label="SHIPMENTCOST.CANCEL"
				/>
			</div>
		</section>
	);
}

export default defaultTemplate(ImportBillingTemplate);

const TrackingResultInfo = observer(({ shipmentCostViewStore: { trackingNumbersResult }, t }) => {
	return (
		<div className="shipment-cost__summary">
			<div className="shipment-cost__summary__item">
				<label className="form__group__label">{t('SHIPMENTCOST.EXISTING')}</label>
				<p className="type--lrg type--wgt--bold">{trackingNumbersResult.existingCharges}</p>
			</div>
			<div className="shipment-cost__summary__item">
				<label className="form__group__label">{t('SHIPMENTCOST.NEW')}</label>
				<p className="type--lrg type--wgt--bold">{trackingNumbersResult.newCharges}</p>
			</div>
			<div className="shipment-cost__summary__item">
				<label className="form__group__label">{t('SHIPMENTCOST.IGNORED')}</label>
				<p className="type--lrg type--wgt--bold">{trackingNumbersResult.ignored}</p>
			</div>
		</div>
	);
});
